import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class EstatePlanPartyType extends Enum {
  key!: string;
  value!: string;
  description!: string;
  static INDIVIDUAL: EstatePlanPartyType = {
    key: 'individual',
    get value(): string {
      return Lang.t('estate.individual');
    },
    get description(): string {
      return Lang.t('estate.individual');
    }
  };

  static COUPLE: EstatePlanPartyType = {
    key: 'couple',
    get value(): string {
      return Lang.t('estate.couple');
    },
    get description(): string {
      return Lang.t('estate.couple-discount');
    }
  };
}
